import CreateAdminApi from './admin';
import CreateAppApi from './app';
import CreateBusinessApi from './business';

export default (Vue) => {
  Vue.prototype.$api = {};
  if (Vue.prototype.$utils.isApp()) {
    return CreateAppApi(Vue);
  }
  if (Vue.prototype.$utils.isBusiness()) {
    return CreateBusinessApi(Vue);
  }
  return CreateAdminApi(Vue)
}



// WEBPACK FOOTER //
// ./src/api/index.js